import React from 'react';
import TimelineGraficIcon from '@mui/icons-material/TimelineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HistoryIcon from '@mui/icons-material/History';
import Battery100 from '@mui/icons-material/BatteryFullRounded';
import Battery20 from '@mui/icons-material/Battery20Rounded';
import Battery30 from '@mui/icons-material/Battery30Rounded';
import Battery50 from '@mui/icons-material/Battery50Rounded';
import Battery60 from '@mui/icons-material/Battery60Rounded';
import Battery80 from '@mui/icons-material/Battery80Rounded';
import Battery90 from '@mui/icons-material/Battery90Rounded';
import LightIcon from '@mui/icons-material/WbIncandescent';
import HumidityIcon from '@mui/icons-material/Opacity';
import MapIcon from '@mui/icons-material/Map';
import TemperatureIcon from './temperature';
import OrientationIcon from './orientation';
import PressureIcon from './pressure';
import ShockIcon from './shock';

// issue https://github.com/mui/material-ui/issues/40032#issuecomment-1848858497
const fill = 'currentColor';

export default (identifier, device = {}, value) => {
  switch (identifier) {
    case 't':
    case 'temperature':
      return <TemperatureIcon fill={fill} />;
    case 'h':
    case 'humidity':
      return <HumidityIcon />;
    case 'ch':
    case 'battery': {
      if (value === 100) {
        return <Battery100 />;
      }
      if (value >= 90) {
        return <Battery90 />;
      }
      if (value >= 80) {
        return <Battery80 />;
      }
      if (value >= 60) {
        return <Battery60 />;
      }
      if (value >= 50) {
        return <Battery50 />;
      }
      if (value >= 30) {
        return <Battery30 />;
      }
      if (value > 0) {
        return <Battery20 className="red" />;
      }
      if (value === 0) {
        return <Battery20 className="red" />;
      }
      if (device.type === 'beacon') {
        return null;
      }
      return null;
    }
    case 'Shipment-battery': {
      return <Battery90 />;
    }
    case 'info': {
      return <InfoOutlinedIcon />;
    }
    case 'events': {
      return <HistoryIcon />;
    }
    case 'orientation': {
      return <OrientationIcon fill={fill} />;
    }
    case 'pressure': {
      return <PressureIcon fill={fill} />;
    }
    case 'light': {
      return <LightIcon />;
    }
    case 'shock': {
      return <ShockIcon fill={fill} />;
    }
    case 'map': {
      return <MapIcon />;
    }
    default:
      return <TimelineGraficIcon />;
  }
};
